import {
  OreButton,
  OreHeading,
  OreInput,
  OreStack,
  OreText,
  SvgResetData,
} from '@edenredespana/oreneta'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { AutoEnrollmentTranslation } from '@/AutoEnrollment/ui/autoEnrollmentTranslation'
import { useAutoEnrollment } from '@/AutoEnrollment/ui/context'
import { FillWithOwnerCases, Step2Form } from '@/AutoEnrollment/ui/hooks'
import { handleErrors } from '@/Shared/ui/form'

export const Step2ContactData = (): JSX.Element => {
  const { t } = useTranslation()
  const { register, formState } = useFormContext<Step2Form>()
  const { errors } = handleErrors(formState)

  const { fillWithOwnerData } = useAutoEnrollment()

  return (
    <OreStack placeContent="stretch" space="large">
      <OreHeading as="h2" size="headline-md">
        {t(AutoEnrollmentTranslation.storeContactData.title)}
      </OreHeading>
      <OreText>{t(AutoEnrollmentTranslation.storeContactData.description)}</OreText>
      <OreStack direction="row" placeContent="start">
        <OreButton
          category={'tertiary'}
          icon={<SvgResetData />}
          iconAlign={'left'}
          onClick={() => fillWithOwnerData(FillWithOwnerCases.manager)}
          data-testid="fillWithOwnerData"
        >
          {t(AutoEnrollmentTranslation.paymentContactData.fillWithOwnerData)}
        </OreButton>
      </OreStack>
      <OreInput
        {...register('contactName')}
        {...errors('contactName')}
        id="contactName"
        label={t(AutoEnrollmentTranslation.storeContactData.data.name.label)}
        placeholder={t(AutoEnrollmentTranslation.storeContactData.data.name.placeholder)}
        required
        maxLength={20}
      />
      <OreStack direction="row" space="large" placeContent="stretch" sameSize>
        <OreInput
          {...register('contactSurname1')}
          {...errors('contactSurname1')}
          id="contactSurname1"
          label={t(AutoEnrollmentTranslation.storeContactData.data.surname1.label)}
          placeholder={t(
            AutoEnrollmentTranslation.storeContactData.data.surname1.placeholder,
          )}
          required
          maxLength={20}
        />
        <OreInput
          {...register('contactSurname2')}
          {...errors('contactSurname2')}
          id="contactSurname2"
          label={t(AutoEnrollmentTranslation.storeContactData.data.surname2.label)}
          placeholder={t(
            AutoEnrollmentTranslation.storeContactData.data.surname2.placeholder,
          )}
          maxLength={20}
        />
      </OreStack>
      <OreStack direction="row" space="large" placeContent="stretch" sameSize>
        <OreInput
          {...register('contactEmail')}
          {...errors('contactEmail')}
          id="contactEmail"
          label={t(AutoEnrollmentTranslation.storeContactData.data.email.label)}
          type="email"
          placeholder={t(
            AutoEnrollmentTranslation.storeContactData.data.email.placeholder,
          )}
          required
          maxLength={255}
        />
        <OreInput
          {...register('contactPhone')}
          {...errors('contactPhone')}
          id="contactPhone"
          label={t(AutoEnrollmentTranslation.storeContactData.data.phone.label)}
          type="tel"
          placeholder={t(
            AutoEnrollmentTranslation.storeContactData.data.phone.placeholder,
          )}
          required
          maxLength={255}
        />
      </OreStack>
    </OreStack>
  )
}
